import React, { memo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';
import type { Props } from './types.tsx';

export const ProjectBreadcrumbs = memo<Props>(
	({
		baseUrl,
		boardId,
		boardName,
		projectKey,
		projectName,
		projectId,
		isSimplifiedProject,
		chart,
	}: Props) => {
		const { formatMessage } = useIntl();
		const reportsHref = fg('reports-overview-page-migration')
			? `/jira/software/c/projects/${projectKey}/boards/${boardId}/reports`
			: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;

		return (
			<ProjectBreadcrumb
				baseUrl={baseUrl}
				projectKey={projectKey}
				projectName={projectName}
				projectId={projectId}
				isSimplifiedProject={isSimplifiedProject}
			>
				<Breadcrumb
					breadcrumb={{
						text: boardName,
						href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
						type: 'boardName',
						analyticsAttributes: {
							nextGenProject: isSimplifiedProject,
							projectConfig: isSimplifiedProject ? 'next-gen' : 'classic',
						},
						analyticsFields: {
							name: 'navigateToSubProject',
							containerId: projectId,
							containerType: 'project',
						},
					}}
				>
					{chart && (
						<Breadcrumb
							breadcrumb={{
								text: formatMessage(messages.projectReportBreadcrumb),
								href: reportsHref,
							}}
						/>
					)}
				</Breadcrumb>
			</ProjectBreadcrumb>
		);
	},
);
